module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-send-check-0b1eb6b4556d7d086598524d156205e6.png";